class VersionHelper {
    static getNumberArray(str) {
        return str
            .split('.')
            .map(Number)
            .map((n) => (isNaN(n) ? 0 : n));
    }
    // target이 작거나 같으면 true
    static isLower(target, compare) {
        const targetArr = this.getNumberArray(target);
        const compareArr = this.getNumberArray(compare);
        const len = Math.max(targetArr.length, compareArr.length);
        let result = -1;
        let current = 0;
        while (result < 0 && len > current) {
            if (targetArr[current] > compareArr[current])
                result = +true;
            if (targetArr[current] < compareArr[current])
                result = +false;
            current++;
        }
        return result <= 0;
    }
}
export default VersionHelper;
